import type { SurveyTab } from '@/store/mainSlice';

export const getDefaultSurveyTab = (entriesCount: number): SurveyTab => {
   return entriesCount > 0 ? 'responses' : 'survey';
};

export const SURVEY_TABS = {
   SURVEY: 'survey' as SurveyTab,
   RESPONSES: 'responses' as SurveyTab,
   STATISTICS: 'statistics' as SurveyTab,
} as const;

export const isValidSurveyTab = (key: unknown): key is SurveyTab => {
   return Object.values(SURVEY_TABS).includes(key as SurveyTab);
};
